import { render, staticRenderFns } from "./poiCategories.vue?vue&type=template&id=6c311198&"
import script from "./poiCategories.vue.js?vue&type=script&lang=js&"
export * from "./poiCategories.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports